import { FormControl, FormGroup, Validators } from '@angular/forms';
import { StudyFile } from '../Study/study-file.model';

export class MediaCategory {
  id: number;
  name: string;
  shortName: string;
  matched?: any;
  mediaGroupName?: string;
  mediaGroupId?: any;
  leftOrRight?: string;
  groupLeftOrRight?: string;
  foreOrHind?: string;
  nameVariationCount?: any;
  nameVariation?: any;
  hasSaleTemplates: boolean;
  sortOrder: any;
  assignedFileName?: string;
  isShowReplace: boolean;
  isShowAssign: boolean;
  matchedStudyFileIds: number[];
  studyFiles: StudyFile[];
  isRequired: boolean;

  isSelected?: boolean;
  selected?: boolean;

  static asFormGroup(category: MediaCategory): FormGroup {
    const fg = new FormGroup({
      name: new FormControl(category?.name, Validators.required),
      mediaGroupId: new FormControl(category?.mediaGroupId ?? 0, [
        Validators.required,
        Validators.pattern(/^[1-9]*$/),
      ]),
      leftOrRight: new FormControl(
        category?.leftOrRight ?? 'Left',
        Validators.required
      ),
      foreOrHind: new FormControl(
        category?.foreOrHind ?? ''
      ),
      shortName: new FormControl(
        category?.shortName ?? ''
      ),
    });
    return fg;
  }
}
